"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfflineRechargeGuideRequest = void 0;
var OfflineRechargeGuideRequest = /** @class */ (function () {
    function OfflineRechargeGuideRequest() {
    }
    return OfflineRechargeGuideRequest;
}());
exports.OfflineRechargeGuideRequest = OfflineRechargeGuideRequest;
;
//# sourceMappingURL=offlineRechargeGuide.request.js.map